import { updateField } from 'vuex-map-fields'
import { findIndex } from 'lodash'
import Vue from 'vue'

export default {
  UPDATE_DOCUMENTS_LIST (state, payload) {
    state.documentsList = payload
  },
  SET_ERROR (state, payload) {
    state.error = payload
  },
  SET_SEARCH_QUERY (state, payload) {
    state.searchQuery = payload
  },
  UPDATE_CURRENT_DOCUMENT (state, payload) {
    state.currentDocument = payload
  },
  UPDATE_FOLDERS_TREE_CONTENT (state, payload) {
    state.foldersTreeContent = payload
  },
  UPDATE_ITEM_DISPLAY_SETTINGS (state, payload) {
    state.itemsDisplaySettings[payload.name] = payload.value
  },
  UPDATE_ITEMS_TABLE_CONTENT (state, payload) {
    state.itemsTableContent = payload
  },
  UPDATE_ITEMS_TABLE_QUANTITY (state) {
    state.currentDocument.records.forEach((element) => {
      const index = findIndex(state.itemsTableContent, (o) => {
        return o.nomenklatura_id === element.nomenklatura_id
      })
      if (index >= 0) {
        let newItem = state.itemsTableContent[index]
        newItem.kolichestvo = element.kolichestvo
        newItem.name = element.name
        newItem.tsena = element.tsena
        Vue.set(state.itemsTableContent, index, newItem)
      }
    })
  },
  RESET_ITEMS_TABLE_QUANTITY (state) {
    state.itemsTableContent.forEach((element, index) => {
      state.itemsTableContent[index].kolichestvo = ''
    })
  },
  SET_CURRENT_FOLDER_ID (state, payload) {
    state.currentFolderId = payload
  },
  SET_IS_SAVING (state, payload) {
    state.isSaving = payload
  },
  ADD_RECORD_TO_DOCUMENT (state, payload) {
    state.currentDocument.records.push(payload)
  },
  UPDATE_RECORD_TO_DOCUMENT (state, payload) {
    const index = findIndex(state.currentDocument.records, (o) => {
      return o.nomenklatura_id === payload.nomenklatura_id
    })
    if (payload.kolichestvo > 0) {
      Vue.set(state.currentDocument.records, index, payload)
    } else {
      state.currentDocument.records.splice(index, 1)
    }
  },
  DELETE_ROW (state, payload) {
    const index = findIndex(state.currentDocument.records, (o) => {
      return o.nomenklatura_id === payload.nomenklatura_id
    })
    state.currentDocument.records.splice(index, 1)
  },
  SET_TABLE_LOADING (state, payload) {
    state.tableLoading = payload
  },
  TOGGLE_TREE_SIDEBAR (state, payload) {
    state.treeSideBar = !state.treeSideBar
  },
  UPDATE_DOC_NAME (state, payload) {
    state.currentDocument.name = payload
  },
  SET_DEFAULT_DOCUMENT (state, payload) {
    state.defaultDocument = payload
  },
  updateField
}
